module.exports = __webpack_public_path__ + "img/feel-logo.256771c8.png";